import { useTranslation } from "react-i18next";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import HeadsetIcon from "@/assets/Icons/headset_support.svg?react";
import FXIcon from "@/assets/Icons/fx.svg?react";
import { ChartBarIcon } from "@heroicons/react/24/outline";
import { Button } from "@/components/Button";

export const ExploreOurSolutionsBanner = () => {
  const [t] = useTranslation("global");

  const features = [
    {
      icon: <ChartBarIcon className="w-5 h-5" />,
      text: t("ExploreOurSolutions.Feature1"),
    },
    {
      icon: <HeadsetIcon className="w-5 h-5" />,
      text: t("ExploreOurSolutions.Feature2"),
    },
    {
      icon: <FXIcon className="w-5 h-5" />,
      text: t("ExploreOurSolutions.Feature3"),
    },
  ];

  return (
    <div className="flex flex-col md:flex-row w-full gap-10 max-w-screen-xl">
      <div className="flex flex-col gap-8 w-full">
        <div className="flex flex-col md:flex-row w-full items-center gap-8">
          {/* Left column */}
          <div className="flex-1 flex flex-col gap-4 ">
            <div className="flex flex-col gap-4 max-w-lg md:max-w-md lg:max-w-lg text-center md:text-left items-center md:items-start">
              <h2 className="font-optima text-2xl md:text-3xl lg:text-4xl">
                {t("ExploreOurSolutions.Title")}
              </h2>
              <p className="text-base md:text-lg font-bold leading-snug">
                {t("ExploreOurSolutions.Subtitle")}
              </p>
              <p className="text-sm md:text-base text-gray-600">
                {t("ExploreOurSolutions.Paragraph")}
              </p>
              <Button
                className="!bg-[#363254] !border-[#363254] mt-2 !px-8 !py-3 w-fit"
                text={t("ExploreOurSolutions.CTAButton")}
                icon={<ChevronRightIcon className="w-5 h-5" />}
                link={
                  import.meta.env.VITE_BUSINESS_SITE_URL || "https://sendola.com"
                }
                target="_blank"
                rel={["noopener", "noreferrer"]}
              />
            </div>
          </div>

          {/* Right column — feature cards */}
          <div className="flex-1 bg-[#e3f1ea] rounded-3xl md:rounded-r-none py-8 px-6 w-full md:pl-6 flex flex-col gap-4 md:-mr-6 lg:-mr-10 items-center md:items-start">
            <div className="md:-ml-16 flex flex-col gap-4">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl px-6 py-4 flex items-center gap-4 max-w-lg md:max-w-md lg:max-w-lg"
                >
                  <div className="bg-[#efefef] text-primary-dark rounded-full p-2 flex-shrink-0">
                    {feature.icon}
                  </div>
                  <p className="text-sm md:text-base font-semibold">
                    {feature.text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom note */}
        <p
          className="text-sm md:text-base text-center text-gray-500"
          dangerouslySetInnerHTML={{
            __html: t("ExploreOurSolutions.BottomNote"),
          }}
        />
      </div>
    </div>
  );
};
